<template>
  <header
    class="header"
    :class="[
      ui?.root,
      {
        'border-b border-neutral-muted!': !isWithBg,
      },
    ]"
  >
    <UContainer class="flex items-center justify-between">
      <NuxtLink class="logo" :class="ui?.logo" to="/">
        <p
          v-if="false"
          class="logo-title"
          :class="[
            ui?.logoTitle,
            {
              'text-white': isWithBg,
              'text-accent-default': !isWithBg,
            },
          ]"
        >
          {{ ORGANIZATION_DATA.title }}
        </p>

        <img class="logo-image" :src="logo" alt="Лого" />

        <p
          v-if="false"
          class="logo-description"
          :class="[ui?.logoDescription, mainTextColor]"
        >
          {{ ORGANIZATION_DATA.slogan }}
        </p>
      </NuxtLink>

      <ClientOnly>
        <div
          v-if="!isMobile && !isSmallTablet"
          class="links"
          :class="ui?.links"
        >
          <template v-for="(link, index) in preparedLinks" :key="index">
            <a v-if="link.href" :href="link.href" :class="[mainTextColor]">
              {{ link.title }}
            </a>

            <NuxtLink v-if="link.to" :class="[mainTextColor]" :to="link.to">
              {{ link.title }}
            </NuxtLink>
          </template>

          <ClientOnly>
            <UDropdownMenu
              v-if="isBigTablet"
              :items="otherLinks"
              label-key="title"
            >
              <UButton icon="i-local-ellipsis" variant="ghost" />
            </UDropdownMenu>
          </ClientOnly>
        </div>
      </ClientOnly>

      <div class="top-right flex gap-3 max-md:gap-2" :class="ui?.topRight">
        <UButton
          variant="outline"
          :color="isWithBg ? 'brand' : 'neutral'"
          icon="i-local-search"
          @click="openSearch"
        />

        <ClientOnly>
          <UButton
            v-if="!isMobile"
            :color="isWithBg ? 'brand' : 'neutral'"
            variant="outline"
            icon="i-local-navigation"
            @click="selectCity"
          >
            {{ selectedCity?.label || '' }}
          </UButton>
        </ClientOnly>

        <UButton
          class="cursor-pointer text-button-foreground"
          :class="{
            'text-white': !isWithBg,
          }"
          :color="!isWithBg ? 'primary' : 'neutral'"
          :variant="!isWithBg ? 'solid' : 'soft'"
          icon="i-local-avatar"
        >
          <ClientOnly v-if="!isMobile">Войти</ClientOnly>
        </UButton>

        <ClientOnly>
          <SPMobileMenu
            v-if="isMobile || isTablet"
            :open="isMobileMenuVisible"
            @toggled="isMobileMenuVisible = $event"
          />
        </ClientOnly>
      </div>
    </UContainer>
  </header>
  <slot name="hero"></slot>
</template>

<script lang="ts" setup>
import { links, ORGANIZATION_DATA } from '@/shared'
import CitySelectModal from '~/components/modals/CitySelectModal.vue'
import SearchModal from '~/components/modals/SearchModal.vue'
import type { PageVariant } from '~/types'
import lightLogo from '@/assets/logo/logo-light.svg'
import primaryLogo from '@/assets/logo/logo-primary.svg'
const props = defineProps<{
  variant?: PageVariant
  ui?: {
    root?: string
    logo?: string
    logoTitle?: string
    logoDescription?: string
    links?: string
    topRight?: string
  }
}>()

const breakpoints = useBreakpointsStore()
const { isMobile, isTablet, isSmallTablet, isBigTablet } =
  storeToRefs(breakpoints)

const directoryStore = useDirectoryStore()
const { selectedCity } = storeToRefs(directoryStore)

const overlay = useOverlay()
const citySelectModal = overlay.create(CitySelectModal)
const searchModal = overlay.create(SearchModal)

const openedSearchModals = computed(
  () =>
    overlay.overlays.filter(
      (o) => o.component?.name === 'SearchModal' && o.isOpen,
    )?.length,
)

const isMobileMenuVisible = ref(false)

const isWithBg = computed(() => props.variant !== 'no-bg')

const logo = computed(() => {
  if (props.variant === 'no-bg') {
    return primaryLogo
  }

  return lightLogo
})

const mainTextColor = computed(() => {
  if (props.variant === 'no-bg') {
    return 'text-neutral-default'
  }

  return 'text-white'
})

const preparedLinks = computed(() => {
  if (isTablet.value) {
    return links.filter((_, index) => index < 3)
  }

  return links
})

const otherLinks = computed(() => {
  if (isBigTablet.value) {
    return links.filter((_, index) => index >= 3)
  }
  return []
})

const selectCity = () => {
  citySelectModal.open()
}

const openSearch = () => {
  if (!openedSearchModals.value) {
    searchModal.open()
  }
}
</script>

<style lang="scss" scoped>
.header {
  padding: 16px 0 18px;
  border-bottom: 1px solid var(--color-white-border-light);
}

.logo-image {
  height: 26px;
  // width: 141.5px;
  // margin-bottom: 4px;
}

.logo-title {
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
  font-weight: 700;
  margin-bottom: 4px;
}

.logo-description {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;

  @include max-md {
    font-size: 12px;
  }
}

.links {
  display: flex;
  gap: 30px;
  align-items: center;
}
</style>
